module.exports = __webpack_public_path__ + "8429dcabfa9db80aff7fa3425a10da3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201610_Presse_AVANGA_SZ_256KB.jpg
// module id = 573
// module chunks = 0